<template>
	<div id="shake">
		<div class="bacViews">
			<div class="shakeview">
				<shakeView @data-info="getResultCode" :openid="openid" style="margin: 0 auto"></shakeView>
			</div>
		</div>
	</div>
</template>

<script>
	import shakeView from './components/shakeView.vue'

	export default {
		name: 'app',
		data() {
			return {
				show: false,
				openid: '',
			}
		},
		components: {
			shakeView,
		},
		created() {
			let that = this
			that.openid = this.$route.query.openid
		},
		methods: {
			showText() {
				this.show = true
			},
			runTop() {
				let that = this
				var timing = {
					duration: 2500, //ms
					delay: 0, //ms
					iterations: Infinity, //1, 2, 3 ... Infinity
					direction: 'alternate', //'normal', 'reverse'等
					easing: 'ease-in-out', //'linear', 'ease-in'等
					fill: 'forwards', //'backwards', 'both', 'none', 'auto'
				};
				document.getElementById("top2021").animate([{
					top: '0px'
				}, {
					top: '-50px'
				}], timing);
			},
			getResultCode(code) { //获取到服务器错误反馈

				if (code.ResultCode == 122 || code.ResultCode == 120) { //未签到 返回上一个界面
					if (confirm(code.Message)) {

					} else {

					}
				} else if(code.ResultCode != 124 ) { // 签到成功 未开始 或者正在开奖
					alert(code.Message)
				}
			}

		}
	}
</script>

<style>
	#shake {
		/* font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale; */
		/* text-align: center;
		color: #2c3e50;
		margin-top: 60px; */
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		max-width: 33.75rem;
	}



	.bacViews {
		display: flex;
		align-items: center;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		background-image: url('/images/shakeImg/niuqichongtian.jpg');
		background-size: 100% ;
	}

	.top2021 {
		transform: all 3s;
		width: 100%;
		height: auto;
		position: absolute;
		top: -130px;
	}


	.shakeview {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
		margin-top: 80%;
	}
</style>
